import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../base';
import { MentionPreviewLoader } from './mentionPreviewInterface';

export function createMentionPreviewLoader(
    config: ReportingLoaderBaseConfig
): MentionPreviewLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            const contentQuery = repository.research.content.useLookup(
                context,
                {
                    contentId: props.content,
                },
                {
                    staleTime: Infinity,
                    suspense: false,
                }
            );
            const parentQuery = repository.research.content.useLookup(
                context,
                {
                    contentId: contentQuery.data?.parent!,
                },
                {
                    staleTime: Infinity,
                    suspense: false,
                    enabled: contentQuery.status === 'success',
                }
            );
            const blocksQuery = repository.research.block.useFind(
                context,
                {
                    content: props.content,
                },
                {
                    staleTime: Infinity,
                    suspense: false,
                    enabled: contentQuery.status === 'success',
                }
            );
            return {
                content:
                    contentQuery.status === 'success' && parentQuery.status === 'success'
                        ? {
                              status: contentQuery.status,
                              data: contentQuery.data,
                              parent: parentQuery.data,
                              error: null,
                          }
                        : {
                              status: 'loading',
                              data: null,
                              error: null,
                          },
                block:
                    blocksQuery.status === 'success'
                        ? {
                              status: blocksQuery.status,
                              data: blocksQuery.data,
                              error: null,
                          }
                        : {
                              status: 'loading',
                              data: null,
                          },
            };
        },
    };
}
